import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { downloadPass, downloadGooglePass } from '../../redux/actions/booking' // Import the Redux action
import apple_wallet from '../../assets/img/wallet_icon/apple_wallet.png'
import google_wallet from '../../assets/img/wallet_icon/google_wallet.png'
import { iOS, isPermissionExist, sortPortalPermissionByKey } from '../../utils/helper'

const PassWalletButtons = ({ ticketId, googleWalletApi, appleWalletApi, notify, isAction = false, partnerDetails = {} }) => {
    const dispatch = useDispatch()
    let restritedPermission = sortPortalPermissionByKey(partnerDetails?.customer_portal_permission, 'Restricted Permissions')
    const isWalletPermission = isPermissionExist(restritedPermission, 'Display Wallet Pass')
    // Function to handle wallet pass download
    const handleDownload = (type = 'apple') => {
        if (type === 'apple') {
            dispatch(downloadPass(ticketId, appleWalletApi)).then(() => {
                notify('Success', 'Wallet Pass Downloaded successfully!')
            }).catch((err) => {
                if (err?.errors?.message) {
                    notify('error', err.errors.message) // Tooltip notification
                }
            })
        } else {
            dispatch(downloadGooglePass(ticketId, googleWalletApi)).then((res) => {
                if (res?.errors?.message) {
                    notify('error', res?.errors?.message)
                }
            }) // Dispatch Redux action   
        }
    }
    return <>
        {isWalletPermission ? <button
            title={isAction ? `Add to ${iOS ? 'Apple' : 'Google'} Wallet` : ''}
            type="button"
            onClick={() => handleDownload(iOS ? 'apple' : 'google')}
            className={isAction ? 'btn border-btn bg-dark text-white p-1 px-2' : 'btn w-100 border-btn d-flex gap-2 justify-content-center align-items-center bg-dark text-white py-2 px-1 rounded-5'}
        >
            <img
                src={iOS ? apple_wallet : google_wallet}
                alt={iOS ? 'Apple Wallet' : 'Google Wallet'}
                style={{ height: `${isAction ? '14px' : '25px'}` }} // Adjust size
            />
            {isAction ? null : <span className='ms-2'>Add to {iOS ? 'Apple' : 'Google'} Wallet</span>}
        </button> : null}
    </>
}

PassWalletButtons.propTypes = {
    ticketId: PropTypes.string.isRequired,
    googleWalletApi: PropTypes.string.isRequired,
    appleWalletApi: PropTypes.string.isRequired,
    notify: PropTypes.func,
    isAction: PropTypes.bool,
    partnerDetails: PropTypes.object
}

export default PassWalletButtons
